import { useField } from "formik";
import { useMemo } from "react";

const useFieldError = (name) => {
  const [, meta] = useField(name);

  const hasError = useMemo(
    () => meta.touched && !!meta.error,
    [meta.error, meta.touched]
  );

  return hasError;
};

export default useFieldError;
